import { render, staticRenderFns } from "./EmployeeAbsent.vue?vue&type=template&id=d10cd4b8"
import script from "./EmployeeAbsent.vue?vue&type=script&lang=js"
export * from "./EmployeeAbsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports